var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[(!_vm.isMobile)?_c('we-bar',{attrs:{"branchList":_vm.branchList}}):_c('we-bar-m',{attrs:{"branchList":_vm.branchList}}),_c('we-branch-items',{attrs:{"isMobile":_vm.isMobile,"branchList":_vm.branchList}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }